import React from "react";
import ReactDOM from "react-dom/client";
import "src/css/index.css";
import App from "src/modules/App";
import reportWebVitals from "src/reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
